import { getMessages } from 'app/store/constants';

export const LABEL_BOARD_NAME = getMessages().getText('common.board');
